import { useInstallPrompt } from "../hooks/useInstallPrompt";

// Aviso de instalación compartido entre todas las vistas de la PWA de
// Montacargas: botón de instalar en Android/Chrome e instrucciones
// manuales en iOS (donde no existe beforeinstallprompt).
function InstallBanner() {
  const { canInstall, installed, promptInstall, showIosInstructions } = useInstallPrompt();

  if (installed) return null;

  if (canInstall) {
    return (
      <div className="alert alert-primary d-flex justify-content-between align-items-center py-2 px-3 mb-2">
        <span className="small mb-0">Instala la app para usarla sin conexión.</span>
        <button type="button" className="btn btn-primary btn-sm" onClick={promptInstall}>
          Instalar
        </button>
      </div>
    );
  }

  if (showIosInstructions) {
    return (
      <div className="alert alert-secondary py-2 px-3 mb-2">
        <span className="small mb-0">
          En iPhone: toca <strong>Compartir</strong> y luego <strong>"Agregar a inicio"</strong>.
        </span>
      </div>
    );
  }

  return null;
}

export default InstallBanner;
